import VueMarkdownEditor from '@kangc/v-md-editor'
import '@kangc/v-md-editor/lib/style/base-editor.css'
import vuepressTheme from '@kangc/v-md-editor/lib/theme/vuepress.js'
import '@kangc/v-md-editor/lib/theme/style/vuepress.css'
import Prism from 'prismjs'

import createTodoListPlugin from '@kangc/v-md-editor/lib/plugins/todo-list/index'
import '@kangc/v-md-editor/lib/plugins/todo-list/todo-list.css'

import createAlignPlugin from '@kangc/v-md-editor/lib/plugins/align'

import createEmojiPlugin from '@kangc/v-md-editor/lib/plugins/emoji/index'
import '@kangc/v-md-editor/lib/plugins/emoji/emoji.css'

import createTipPlugin from '@kangc/v-md-editor/lib/plugins/tip/index'
import '@kangc/v-md-editor/lib/plugins/tip/tip.css'

import createCopyCodePreview from '@kangc/v-md-editor/lib/plugins/copy-code/preview'
import '@kangc/v-md-editor/lib/plugins/copy-code/copy-code.css'

import VMdPreview from '@kangc/v-md-editor/lib/preview'
import '@kangc/v-md-editor/lib/style/preview.css'

VueMarkdownEditor.use(vuepressTheme, {Prism})
VueMarkdownEditor.use(createTodoListPlugin())
VueMarkdownEditor.use(createAlignPlugin())
VueMarkdownEditor.use(createEmojiPlugin())
VueMarkdownEditor.use(createTipPlugin())
VueMarkdownEditor.use(createCopyCodePreview())

VMdPreview.use(vuepressTheme, {Prism})
VMdPreview.use(createTodoListPlugin())
VMdPreview.use(createAlignPlugin())
VMdPreview.use(createEmojiPlugin())
VMdPreview.use(createTipPlugin())
VMdPreview.use(createCopyCodePreview())

export {VueMarkdownEditor, VMdPreview}



// WEBPACK FOOTER //
// ./src/utils/markdown.js